import React from 'react';
import { useState } from 'react';
import {injectIntl} from "react-intl";
import {connect} from "react-redux";
import {GET_TEMETTU_REPORTS, TEMETTU_REPORT_DOWNLOAD_AS_EXCEL} from "../../constants/uri";
import {checkHttpStatus, post} from "../../utils/RestUtilsWithAxios";
import Paper from "@material-ui/core/Paper";
import Fade from "@material-ui/core/Fade";
import MyTable from '../../components/MyTable';
import {makeStyles} from "@material-ui/core/styles/index";
import Typography from "@material-ui/core/Typography";
import HkFilterPanel from './HkFilterPanel';
import * as Globals from '../../constants/globals';
import * as DownloadUtils from '../../utils/downloadUtils';
import { alertBox } from '../../components/BoxProvider';

const useStyles = makeStyles(theme => ({
    root: {
        width: '100%',
    },
    paper: {
        marginBottom: theme.spacing(2),
        margin:'auto',
        padding: 30,
        paddingTop:20
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        margin: 'auto',
        width: 'fit-content',
    },
    formControl: {
        marginTop: theme.spacing(2),
        minWidth: 120,
    },
    formControlLabel: {
        marginTop: theme.spacing(1),
    },
    messageContainer: {
        marginBottom: theme.spacing(4),
        marginTop: theme.spacing(4),
    },
    whiteText: {
        color:'white'
    }
}));

/**
 * TemettuReportPage
 * @param props
 * @return {*}
 * @constructor
 */
function TemettuReportPage(props) {
    /**
     * prepareItemArray
     * @param array
     * @return {Array}
     */
    function prepareItemArray(array) {
        var setArray = [];
        for(var i=0;i<array.length;i++){
            var valueItem = {};
            valueItem.values = [];
            valueItem.values.push(array[i].kiymet);
            valueItem.values.push(array[i].turu);
            valueItem.values.push(array[i].dagitimTarihi);
            valueItem.values.push(array[i].nakitBrutOran);
            valueItem.values.push(array[i].nakitNetOran);
            valueItem.values.push(array[i].sirketSermaye);
            setArray.push(valueItem);
        }
        return setArray;
    }

    const headRows = [
        { id: 'titleCol', numeric: false, disablePadding: false, label: 'Kıymet' },
        { id: 'typeCol', numeric: false, disablePadding: false, label: 'Tür' },
        { id: 'dateCol', numeric: false, date: true, disablePadding: false, label: 'Dağıtım Tarihi' },
        { id: 'brutCol', numeric: true, disablePadding: false, label: 'Nakit Brüt Oran', decimal:5 },
        { id: 'netCol', numeric: true, disablePadding: false, label: 'Nakit Net Oran', decimal:5 },
        { id: 'sermayeCol', numeric: true, disablePadding: false, label: 'Sermaye', decimal: 5 }
    ];

    const alignment = ['left', 'left', 'left','right','right'];

    /**
     * filterReports
     * @param selectedBeginDate
     * @param selectedEndDate
     * @param selectedIhrMember
     */
    function filterReports(selectedBeginDate,selectedEndDate,selectedIhrMember) {
        var endDate = new Date(selectedEndDate.substring(0,4)+'-'+selectedEndDate.substring(4,6)+'-'+selectedEndDate.
        substring(6,8));
        var beginDate = new Date(selectedBeginDate.substring(0,4)+'-'+selectedBeginDate.
        substring(4,6)+'-'+selectedBeginDate.substring(6,8));
        
        if (beginDate.getTime() > endDate.getTime()) {
            alertBox("", 'Başlangıç Tarihi Bitiş Tarihinden büyük olamaz.', Globals.ALERT_ERROR, props.intl);
            return;
        }
        post(GET_TEMETTU_REPORTS,{beginDate:selectedBeginDate,endDate:selectedEndDate,mbrId:selectedIhrMember})
            .then(function (response) {
                setReportList([]);
                setReportList(response.data);
                setFade(true);
            })
            .catch(function (error) {
                setFade(true);
                checkHttpStatus(error,props.intl);
            })
    }

    /**
     * download
     * @param serviceName
     */
    function download(serviceName) {
        post(serviceName, {temettuList: reportList})
            .then(function (response) {
                if (serviceName === TEMETTU_REPORT_DOWNLOAD_AS_EXCEL)
                    DownloadUtils.downloadFileByContentExcel(response.data, "Temettü.xls", Globals.CONTENT_TYPE_EXCEL);
                
            })
            .catch(function (error) {
                checkHttpStatus(error, props.intl);
            })
    }

    const [reportList,setReportList] = useState([]);
    const [fade,setFade] = useState(false);
    const classes = useStyles();

    return(
        <div className={classes.root}>
            <Paper className={classes.paper} >
                <HkFilterPanel initOnOpen={true} filterReports={filterReports} ihrMembers={props.ihrMembers}/>
                <Fade in={fade}>
                    {
                        reportList.length > 0 ? 
                            <div>
                                <MyTable expandable = {false}
                                            intl={props.intl}
                                            tableRows={prepareItemArray(reportList)}
                                            headRows={headRows}
                                            alignment = {alignment}
                                            defaultSort='desc'
                                            defaultSortIndex={2}
                                            dateTimeColumns={[2]}
                                            numericColumns={[3, 4]}
                                            printOption={true}
                                            downloadAsExcel={() => download(TEMETTU_REPORT_DOWNLOAD_AS_EXCEL)}
                                            printHeader='TEMETTÜ BİLGİLERİ RAPORU'
                                />
                            </div>
                            :
                            <Typography align='center' classes={{h6: classes.messageContainer}} variant='h6'>
                                {props.intl.formatMessage({id:"RIGHTS_INFORMATION.MESSAGE.DATA_NOT_FOUND"})}
                            </Typography>
                    }
                </Fade>
            </Paper>
            
        </div>
    )
}

/**
 * injectIntl
 */
export default injectIntl(
    connect(
        null,
    )(TemettuReportPage)
);